(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elvorah-description-charts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elvorah-description-charts')) {
    customElements.define('elvorah-description-charts', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          this.root = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
          if (!this.root) return;
          this.resizeObserver = new ResizeObserver(() => this.updateHints());
          this.enhance();
          this.observer = new MutationObserver(() => this.enhance());
          this.observer.observe(this.root, { childList: true, subtree: true });
          document.fonts.ready.then(() => this.isConnected && this.updateHints());
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else this.start();
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
      enhance() {
        this.root.querySelectorAll('.product__description, .product-description').forEach(description => {
          description.querySelectorAll('table.elvorah-size-table, .elvorah-size-scroll table, table.ovc-size-table').forEach(table => {
            if (table.hasAttribute('data-elvorah-chart')) return;
            description.setAttribute('data-elvorah-chart-description', '');
            this.enhanceTable(table, description);
          });
        });
        this.updateHints();
      }
      enhanceTable(table, description) {
        const properties = ['width', 'min-width', 'max-width', 'height', 'padding', 'padding-left', 'padding-right', 'font-size', 'line-height', 'letter-spacing', 'white-space', 'word-break', 'overflow-wrap', 'table-layout', 'text-align', 'background', 'background-color', 'color', 'border', 'border-collapse', 'margin'];
        [table, ...table.querySelectorAll('th,td,col')].forEach(element => {
          properties.forEach(property => element.style.removeProperty(property));
          element.removeAttribute('width');
        });
        table.classList.add('elvorah-size-table');
        table.setAttribute('data-elvorah-chart', '');
        let wrapper = table.parentElement;
        if (!wrapper.matches('.elvorah-size-scroll') || wrapper.querySelectorAll('table').length !== 1) {
          wrapper = document.createElement('div');
          table.before(wrapper);
          wrapper.append(table);
        }
        wrapper.classList.add('elvorah-size-scroll');
        wrapper.setAttribute('data-elvorah-chart-scroll', '');
        wrapper.setAttribute('role', 'region');
        if (!wrapper.hasAttribute('aria-label')) {
          const heading = table.closest('.ovc-size')?.querySelector('h3,h4');
          wrapper.setAttribute('aria-label', heading?.textContent.trim() || table.rows[0]?.textContent.trim() || this.dataset.label);
        }
        for (let ancestor = wrapper.parentElement; ancestor && ancestor !== description; ancestor = ancestor.parentElement) {
          if (ancestor.style.overflowX === 'auto' || ancestor.style.overflowX === 'scroll') {
            ancestor.style.removeProperty('overflow-x');
            ancestor.setAttribute('data-elvorah-chart-ancestor', '');
          }
        }
        const previous = wrapper.previousElementSibling;
        if (previous?.tagName === 'P' && /^(Swipe left or right to view the full chart\.|Swipe to view all sizes)$/.test(previous.textContent.trim())) {
          previous.setAttribute('data-elvorah-old-hint', '');
        }
        const hint = document.createElement('p');
        hint.setAttribute('data-elvorah-chart-hint', '');
        hint.textContent = this.dataset.hint;
        hint.hidden = true;
        wrapper.before(hint);
        wrapper.chartHint = hint;
        const rows = [...table.rows];
        const complex = rows.some(row => [...row.cells].some(cell => cell.colSpan > 1 || cell.rowSpan > 1));
        if (complex) {
          table.setAttribute('data-elvorah-chart-complex', '');
        } else if (rows.length) {
          const headers = [...rows[0].cells].map(cell => cell.textContent.trim());
          const methodIndex = headers.findIndex(text => /measurement method/i.test(text));
          const pointIndex = headers.findIndex(text => /measurement point/i.test(text));
          const stickyIndex = pointIndex >= 0 ? pointIndex : 0;
          const widths = headers.map((header, index) => {
            const values = rows.slice(1).map(row => row.cells[index]?.textContent.trim() || '');
            const longText = values.some(value => value.length > 24);
            if (index === methodIndex) return 124;
            if (index === pointIndex) return 112;
            if (index === 0) return /category|measurement/i.test(header) ? 140 : 64;
            if (longText) return 120;
            if (header.length > 18) return 112;
            if (header.length > 10) return 94;
            return values.some(value => value.length > 10) ? 98 : 68;
          });
          table.querySelectorAll('colgroup').forEach(group => group.remove());
          const group = document.createElement('colgroup');
          widths.forEach(width => {
            const col = document.createElement('col');
            col.style.width = `${width}px`;
            group.append(col);
          });
          const firstSection = table.querySelector('thead,tbody,tr');
          if (firstSection) table.insertBefore(group, firstSection);
          else table.append(group);
          table.style.setProperty('--elvorah-chart-width', `${widths.reduce((sum, width) => sum + width, 0)}px`);
          rows.forEach(row => [...row.cells].forEach((cell, index) => {
            if (index === stickyIndex) cell.setAttribute('data-chart-sticky', '');
            if (index === methodIndex || index === pointIndex || (index === 0 && widths[0] > 100)) cell.setAttribute('data-chart-prose', '');
          }));
        }
        this.resizeObserver.observe(wrapper);
        this.resizeObserver.observe(table);
      }
      updateHints() {
        this.root?.querySelectorAll('[data-elvorah-chart-scroll]').forEach(wrapper => {
          const overflows = wrapper.clientWidth > 0 && wrapper.scrollWidth > wrapper.clientWidth + 2;
          if (wrapper.chartHint) wrapper.chartHint.hidden = !overflows;
          if (overflows) wrapper.setAttribute('tabindex', '0');
          else wrapper.removeAttribute('tabindex');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
